import { Component } from '@angular/core';

import { SkyModalInstance } from '../../core';

import { SkyModalDemoContext } from './modal-demo-context';


export class SkyModalDemoFormComponent {
  public title = 'Hello world';

  constructor(
    public context: SkyModalDemoContext,
    public instance: SkyModalInstance
  ) { }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-demo-modal-form',
  template: `<sky-modal>
  <sky-modal-header>
    {{title}}
  </sky-modal-header>
  <sky-modal-content>
    <div id="docs-modal-content">
      This modal can have content!
    </div>
    <label>
      Value A
      <input type="text" [(ngModel)]="context.valueA">
    </label>
    <p>
      <sky-alert *ngIf="context.eventMessage">
        {{context.eventMessage}}
      </sky-alert>
    </p>
  </sky-modal-content>
  <sky-modal-footer>
    <button
      type="button"
      class="sky-btn sky-btn-primary"
      (click)="instance.save('Something cool')">
      Close
    </button>
  </sky-modal-footer>
</sky-modal>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyModalDemoContext, },
{type: SkyModalInstance, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
